import { Down, Up } from 'grommet-icons';
import React from 'react';

import { Button } from '@/components-new/button';

type ExpandCollapseCellProps = {
  expanded: boolean
  onExpand: () => void;
  onCollapse: () => void;
};

export const ExpandCollapseCell = ({ expanded, onExpand, onCollapse }: ExpandCollapseCellProps) => (
  <Button plain onClick={expanded ? onCollapse : onExpand}>
    {expanded ? <Up/> : <Down/>}
  </Button>
);
